import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class SmartInsightsUpsell extends Model {
  [Type] = 'smart-insights/upsell' as const;

  @attr('boolean') declare trial365Requested: boolean;
}
